<template>
  <v-dialog v-model="show" max-width="600">
    <v-card>
      <v-card-title class="body-1">
        {{
          controller
            ? $vuetify.lang.t('$vuetify.CONTROLLERS.EDIT_CONTROLLER')
            : $vuetify.lang.t('$vuetify.CONTROLLERS.ADD_CONTROLLER')
        }}
        <v-spacer></v-spacer>
        <v-btn icon small @click="show = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text
        class="overflow-y-auto"
        :style="
          $vuetify.breakpoint.smAndDown
            ? 'max-height: 424px;'
            : 'max-height: 584px;'
        "
      >
        <v-form>
          <v-container v-if="loading.type !== 'getWhitelist'">
            <v-row class="d-flex align-center">
              <!-- App -->
              <v-col cols="12" sm="12">
                <v-text-field
                  v-model="localController.Description"
                  :label="$vuetify.lang.t('$vuetify.DESCRIPTION')"
                  outlined
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12">
                <v-text-field
                  v-model="localController.ControllerId"
                  :label="'Controller ID'"
                  outlined
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12">
                <v-select
                  v-model="localController.Type"
                  :items="['PARKING', 'COINFAKER', 'RELAY_IMPULSES', 'IN_BAY']"
                  label="Type"
                  outlined
                  hide-details
                ></v-select>
              </v-col>
              <v-col cols="12" sm="12">
                <v-text-field
                  v-model.number="localController.Version"
                  :label="'Version'"
                  outlined
                  hide-details
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12">
                <v-text-field
                  v-model="localController.PhoneNumber"
                  :label="$vuetify.lang.t('$vuetify.PHONE_NUMBER')"
                  outlined
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12">
                <v-text-field
                  v-model="localController.PinsToLog"
                  :label="'Pins to log'"
                  :placeholder="'1,2,3 ...'"
                  outlined
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12">
                <v-text-field
                  v-model="localController.PinStateActivityMap"
                  :label="'Pin state activity map'"
                  outlined
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12">
                <v-text-field
                  v-model="localController.ActivityRequiredPinStateMap"
                  :label="'Activity mapping to required pin state'"
                  outlined
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12">
                <v-checkbox
                  v-model="localController.DisableAutomaticRestart"
                  label="Disable automatic restart"
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-row class="mt-5">
              <v-btn color="success" text @click="addGate()"
                ><v-icon>mdi-plus</v-icon>Gate</v-btn
              >
            </v-row>
            <div v-if="localController && localController.Gates">
              <v-row
                v-for="(gate, i) in localController.Gates"
                :key="i"
                class="mt-5"
              >
                <v-card class="col-12">
                  <v-toolbar flat>
                    Gate {{ gate.Number }}
                    <v-spacer></v-spacer>
                    <v-icon
                      color="error"
                      @click="removeGate(controller.Gates, i)"
                      >mdi-close</v-icon
                    >
                  </v-toolbar>
                  <v-col cols="12" sm="12">
                    <v-text-field
                      v-model.number="gate.GateNumber"
                      :label="'Number'"
                      outlined
                      hide-details
                      type="number"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <v-select
                      v-model="gate.Activity"
                      :items="['ENTRY', 'EXIT', 'BOTH', 'DRIVER', 'FAKE_COINS']"
                      label="Activity"
                      outlined
                      hide-details
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <v-text-field
                      v-model="gate.Description"
                      :label="'Description'"
                      outlined
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <v-text-field
                      v-model="gate.SignalLowMs"
                      :label="'Signal low duration in ms'"
                      outlined
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <v-text-field
                      v-model="gate.SignalHighMs"
                      :label="'Signal high duration in ms'"
                      outlined
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <v-text-field
                      v-model="gate.CoinPinMapping"
                      :label="'Coin to pin mapping'"
                      placeholder="100:1,200:2 ..."
                      outlined
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <v-select
                      v-model="gate.InhibitInput"
                      :items="[1, 2, 3, 4, 5, 6]"
                      label="Inhibit input"
                      outlined
                      hide-details
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <v-checkbox
                      v-model="localController.UseMultiplier"
                      label="Use multiplier"
                    ></v-checkbox>
                  </v-col>
                </v-card>
              </v-row>
            </div>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          :disabled="localController.Id === 0"
          color="error"
          @click="removeGateController()"
        >
          {{ $vuetify.lang.t('$vuetify.DELETE') }}
        </v-btn>
        <v-btn
          color="primary"
          class="secondary--text"
          @click="saveGateControllerInfo()"
        >
          {{ $vuetify.lang.t('$vuetify.SAVE') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import GateController from '@/models/gate-controller'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'EditGateControllerDialog',
  props: {
    controller: {
      type: Object,
      required: false
    },
    placeId: {
      type: Number,
      required: false
    },
    visible: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      localController: new GateController().getObject()
    }
  },
  computed: {
    ...mapGetters('app', ['loading']),
    show: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.localController = new GateController().getObject()
          this.$emit('close')
        }
      }
    }
  },
  created() {
    if (this.controller) {
      this.localController = this.controller
    }
  },
  methods: {
    ...mapActions('places', [
      'postGateController',
      'deleteGateController',
      'sendGateControllerCommand'
    ]),
    saveGateControllerInfo() {
      this.postGateController({
        placeId: this.placeId,
        controller: this.localController
      }).then(() => {
        this.show = false
      })
    },
    removeGateController() {
      this.deleteGateController({
        placeId: this.placeId,
        controllerId: this.localController.Id
      }).then(() => {
        this.show = false
      })
    },
    addGate() {
      if (!this.localController.Gates) {
        this.localController.Gates = []
      }
      this.localController.Gates.unshift({
        GateControllerId: this.localController.Id
      })
    },
    removeGate(gate, gates, index) {
      gates.splice(index, 1)
    }
  }
}
</script>
